import {Input} from 'antd'

import {Form, FormItem, Button} from 'common/components'
import {useInputFocus} from 'common/hooks'
import {FIELD_RULES} from 'common/constants'
import {useRejectAML} from '..'

interface AMLRejectFormProps {
  amlUuid: string
  onClose: () => void
}

export default function AMLRejectForm({amlUuid, onClose}: AMLRejectFormProps) {
  const {mutate: rejectAML, isMutating: isRejectAMLMutating} = useRejectAML(
    amlUuid,
    onClose
  )
  const inputRef = useInputFocus()

  const handleFinish = (values: any) => rejectAML(values)

  return (
    <Form onFinish={handleFinish}>
      <FormItem name="reason" label="Reject notes" rules={FIELD_RULES}>
        <TextArea
          ref={inputRef}
          placeholder="Write here reason of reject…"
          rows={7}
        />
      </FormItem>
      <Button block htmlType="submit" loading={isRejectAMLMutating}>
        reject aml check
      </Button>
    </Form>
  )
}

const {TextArea} = Input
